import { VStack, Text } from '@chakra-ui/react';
import { WorksheetParticipant } from 'hooks/api/backend/worksheets/useWorksheets';
import React, { ReactElement } from 'react';
import { WorksheetParticipantItem } from './WorksheetParticipantItem';

type Props = {
  participants: WorksheetParticipant[];
};

export const WorksheetParticipants = ({ participants }: Props): ReactElement => {
  return (
    <VStack width="100%" align="stretch" gap="10px" py="l">
      <VStack align="left" gap="10px">
        <Text textStyle="h4.medium">Teilnehmende Lernende</Text>
        <Text textStyle="body.s.regular" color="text.quaternary">
          {participants.length} Lernende sind dem Arbeitsblatt zugeteilt
        </Text>
      </VStack>
      <VStack align="stretch" gap="0">
        {participants.map((participant) => (
          <WorksheetParticipantItem key={participant.userData.id} participant={participant} />
        ))}
      </VStack>
    </VStack>
  );
};
